import { render } from "./ManageKanbanStatusesPage.vue?vue&type=template&id=6bf11429&ts=true"
import script from "./ManageKanbanStatusesPage.vue?vue&type=script&lang=ts"
export * from "./ManageKanbanStatusesPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__